import React from 'react';
import { Label } from '@grubhubprod/gh-cookbook-react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CorpInvoicingPeriod } from 'src/components/enterprise/features/Corporate/components/Form/types/CorporateForm';
import { CookbookRadioWrapper } from 'src/components/CookbookRadioWrapper/CookbookRadioWrapper';

export interface InvoicingPeriodControlProps {
  name: string;
  id: string;
}

export function InvoicingPeriodControl({
  name,
  id,
}: InvoicingPeriodControlProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <>
      <Label aria-label="InvoicingPeriodControl" inputSize="medium">
        Invoicing Period
      </Label>
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingPeriod.WEEKLY}`}
        control={control}
        label="Weekly"
        value={CorpInvoicingPeriod.WEEKLY}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingPeriod.BIWEEKLY}`}
        control={control}
        label="Biweekly"
        value={CorpInvoicingPeriod.BIWEEKLY}
      />
      <CookbookRadioWrapper
        name={name}
        id={`${id}${CorpInvoicingPeriod.MONTHLY}`}
        control={control}
        label="Monthly"
        value={CorpInvoicingPeriod.MONTHLY}
      />
    </>
  );
}
